import React from "react";
import { IoClose } from "react-icons/io5";
import Select from "react-select";
import Button from "../Button";

const Filter = ({
  isOpen,
  onClose,
  filterFields = [],
  filters,
  setFilters,
  applyFilters,
  clearFilters,
}) => {
  const handleInputChange = (e, name) => {
    setFilters((prev) => ({ ...prev, [name]: e.target.value }));
  };

  const handleSelectChange = (selected, name) => {
    setFilters((prev) => ({
      ...prev,
      [name]: selected ? selected.value : "",
    }));
  };

  return (
    <>
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-[1px] z-[9998]"
          onClick={onClose}
        />
      )}
      <div
        className={`fixed top-0 right-0 w-full sm:w-[380px] h-full bg-white border-l border-gray-100 z-[9999] transform transition-transform duration-300 ease-in-out ${isOpen ? "translate-x-0" : "translate-x-full"
          }`}
      >
        <div className="flex flex-col h-full">
          {/* Header */}
          <div className="bg-white border-b border-gray-100 px-6 py-4 flex justify-between items-center shrink-0">
            <div className="flex flex-col">
              <h3 className="text-[14px] font-black text-gray-800 uppercase tracking-[3px]">
                Filter Options
              </h3>
              <div className="w-12 h-1 bg-primary mt-1"></div>
            </div>
            <button
              onClick={onClose}
              className="hover:bg-gray-50 p-2 transition-all border border-gray-100/50 hover:border-gray-200"
            >
              <IoClose size={20} className="text-gray-400 group-hover:text-primary" />
            </button>
          </div>

          {/* Dynamic Fields */}
          <div className="flex-1 overflow-y-auto p-5 bg-[#f8fafc] space-y-5">
            {filterFields.map((field) => (
              <div key={field.name}>
                <label className="block text-[11px] font-bold text-gray-600 uppercase tracking-wider mb-1.5">
                  {field.label}
                </label>
                {field.type === "select" ? (
                  <Select
                    options={field.options || []}
                    value={
                      field.options?.find(
                        (opt) => opt.value === filters[field.name]
                      ) || null
                    }
                    isClearable
                    isSearchable
                    onChange={(selected) =>
                      handleSelectChange(selected, field.name)
                    }
                    styles={{
                      control: (base) => ({
                        ...base,
                        minHeight: '38px',
                        fontSize: '13px',
                        borderRadius: '0',
                        borderColor: '#e2e8f0',
                        boxShadow: 'none',
                        '&:hover': { borderColor: '#3F80F7' }
                      }),
                      menuPortal: (base) => ({ ...base, zIndex: 9999 })
                    }}
                    menuPortalTarget={document.body}
                  />
                ) : (
                  <input
                    type={field.type || "text"}
                    name={field.name}
                    placeholder={field.placeholder || "Enter value..."}
                    value={filters[field.name] || ""}
                    onChange={(e) => handleInputChange(e, field.name)}
                    className="w-full border border-gray-200 bg-white px-3 py-2 text-[13px] rounded-none focus:border-primary focus:outline-none transition-colors"
                  />
                )}
              </div>
            ))}
          </div>

          {/* Action Buttons */}
          <div className="p-4 bg-white border-t border-gray-200 flex gap-3 shrink-0">
            <button
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-600 font-bold text-[12px] uppercase tracking-widest hover:bg-gray-50 transition-colors"
              onClick={() => {
                clearFilters();
                onClose();
              }}
            >
              Reset
            </button>
            <button
              className="flex-1 px-4 py-2 bg-primary text-white font-bold text-[12px] uppercase tracking-widest hover:bg-[#0a2e58] border border-primary transition-colors"
              onClick={() => {
                applyFilters();
                onClose();
              }}
            >
              Apply
            </button>
          </div>
        </div>
      </div>

    </>
  );
};

export default Filter;
